/** Port von `IwmDropdownKategorie.razor` — die Beschriftung ist dort fest verdrahtet. */

import { useEffect, useState } from 'react';

import { categoryApi } from '@/api/services/categoryApi';
import { DropDownList } from '@/components/ui';
import type { ChinaAppSysGroupCategory } from '@/types/entities';

export interface CategoryDropdownProps {
  value: number | null;
  onChange(value: number | null): void;
  readOnly?: boolean;
}

const FIELDS = { value: 'Id', text: 'Bezeichnung' } as const;

export function CategoryDropdown(props: CategoryDropdownProps) {
  const [items, setItems] = useState<ChinaAppSysGroupCategory[]>([]);

  useEffect(() => {
    let active = true;
    void categoryApi.get().then((data) => {
      if (active) setItems(data);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <DropDownList<number, ChinaAppSysGroupCategory>
      value={props.value}
      onChange={(value) => {
        props.onChange(value);
      }}
      items={items}
      fields={FIELDS}
      label="Category"
      readOnly={props.readOnly}
      showClearButton
    />
  );
}

export default CategoryDropdown;
